document.addEventListener('alpine:init', () => {
  Alpine.data('roofData', () => ({
    roofTypes: JSON.parse(document.getElementById('roof-types').textContent),
    supportTypes: [
      {name: 'wall', label: 'Stěna'},
      {name: 'column', label: 'Sloupek'},
    ],
    roofType: '',
    crossSections: {
      rafter: {
        b: 100,
        h: 160,
        mat: 'C24'
      },
      tie: {
        b: 80,
        h: 160,
        mat: 'C24'
      },
      purlin: {
        b: 160,
        h: 200,
        mat: 'C24'
      },
      column: {
        b: 160,
        h: 160,
        mat: 'C24'
      },
      strut: {
        b: 100,
        h: 160,
        mat: 'C24'
      }
    },
    b1: 7.0,
    b2: 0.5,
    b3: 2.1,
    b4: 2.45,
    h1: 2.45,
    h2: 1.47,
    s: 35.0,
    collarSupport: 'roller',
    midPurlinSupport: 'roller',
    bw: 1.0,
    lMid: [4.0],
    lL: 0.7,
    lR: 0.7,
    purlinL: 5.4,
    xHinges: [],
    xHingesUser: [],
    hC: 2.7,
    cS: 0.7,
    supports: ['wall', 'wall'],
    hasStruts: false,
    hasHingesAtJoints: true,
    snowZone: 'II',
    topography: 'normal',
    isPreventedSlidingSnow: true,
    selectedSkChoice: 'ec1',
    sk: {
      ec1: null,
      climamaps: null,
      custom: 1.0
    },
    windZone: 'II',
    terrainCategory: 'III',
    ridgeLevel: 8.0,
    vb0: null,
    roofTile: '',
    iRoofChoice: '',
    insulationType: 'to-the-ledge',
    aboveRoofInsulation: null,
    aboveRoofInsulationThickness: 160,
    innerRoofInsulation: null,
    belowRoofInsulation: null,
    belowRoofInsulationThickness: 100,

    init() {
      // HOLY SHIT IM SO SORRY TO ANYONE WHO HAVE TO READ THIS
      this.$watch('roofType', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('crossSections', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('b1', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('b2', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('b3', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('b4', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('h1', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('h2', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('s', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('collarSupport', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('midPurlinSupport', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('bw', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('lMid', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('lL', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('lR', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('purlinL', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('xHinges', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('xHingesUser', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('hC', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('cS', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('supports', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('hasStruts', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('hasHingesAtJoints', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('snowZone', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('topography', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('isPreventedSlidingSnow', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('selectedSkChoice', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('sk', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('windZone', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('terrainCategory', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('ridgeLevel', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('vb0', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('roofTile', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('iRoofChoice', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('insulationType', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('aboveRoofInsulation', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('aboveRoofInsulationThickness', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('innerRoofInsulation', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('belowRoofInsulation', () => {
        this.$store.resultsData.isSolved = false;
      });
      this.$watch('belowRoofInsulationThickness', () => {
        this.$store.resultsData.isSolved = false;
      });
    }
  }));
});